export const TICK_ICON_SIZE = {
    small: 10,
    medium: 12,
    large: 16,
};
//# sourceMappingURL=consts.js.map